import React, { useState, useCallback, useEffect } from "react";
import { MasterTable } from "../../components/_index";
import AddQuestion from "./AddQuestion";
import { deleteQuestion, getQuestion } from "../../services/question.service";
import { Box, Button } from "@mui/material";
import SearchOutlinedIcon from "@mui/icons-material/SearchOutlined";
import { debounce } from "../../utils/debounce";
import ConfirmBox from "../../components/ConfirmBox/ConfirmBox";
import AddIcon from "@mui/icons-material/Add";
import { showToast } from "../../redux/Reducer/toastReducer";
import { useDispatch } from "react-redux";

const Questions = () => {
  const [data, setData] = useState([]);
  const [tableTotalCount, setTableCount] = useState(0);
  const dispatch = useDispatch();
  const [queryParam, setQueryParam] = useState({
    search: "",
    page: 1,
    limit: 10,
    sortType: "",
    sort: "",
  });

  const GetQuestionData = async () => {
    try {
      const res = await getQuestion(queryParam);
      const modifiedData =
        res?.data.map((e) => ({
          ...e,
          optionLength: e?.options.length,
        })) || [];
      setTableCount(res?.totalCount || 0);
      setData(modifiedData);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    GetQuestionData();
  }, [queryParam.search, queryParam.sort, queryParam.limit, queryParam.page]);

  const columns = [
    { id: "questionName", label: "Question Name" },
    { id: "optionLength", label: "Option" },
  ];

  const [openDrawer, setOpenDrawer] = useState(false);
  const [selectedData, setSelectedData] = useState({});

  const tableOutputEvent = useCallback((params) => {
    setQueryParam((queryParams) => ({
      ...queryParams,
      ...params,
    }));
  }, []);

  const handleAdd = () => {
    setSelectedData({});
    setOpenDrawer(true);
  };
  const handleView = (e) => {
    e.isView = true;
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const handleEdit = (e) => {
    e.isView = false;
    setOpenDrawer(true);
    setSelectedData(e);
  };

  const [confirmDeleteOpen, setConfirmDeleteOpen] = useState(false);
  const [selectedDataId, setSelectedDataId] = useState(null);
  const handleDelete = (e) => {
    setSelectedDataId(e._id);
    setConfirmDeleteOpen(true);
  };

  const deleteFunction = async () => {
    try {
      const res = await deleteQuestion(selectedDataId);
      console.log(res, "RRR");
      setConfirmDeleteOpen(false);
      GetQuestionData();
      dispatch(showToast({ message: res.message, type: "success" }));
    } catch (error) {
      console.log(error);
    }
  };

  const handleCloseDrawer = () => {
    setOpenDrawer(false);
  };

  const debouncedHandleSearch = useCallback(
    debounce((searchText) => {
      setQueryParam((queryParams) => ({
        ...queryParams,
        search: searchText,
      }));
    }, 300),
    []
  );

  const handleSearch = (searchText) => {
    debouncedHandleSearch(searchText);
  };

  return (
    <div className="mainContent">
      <Box sx={{ display: "flex", justifyContent: "space-between" }} mb={2}>
        <Box className="SearchInputBoxContainer">
          <SearchOutlinedIcon className="Search_Icon" />
          <input
            className="SearchInputBox"
            placeholder="Search here"
            onChange={(e) => handleSearch(e.target.value)}
          />
        </Box>
        <Button onClick={handleAdd} className="addButton">
          <AddIcon />
          Add Question
        </Button>
      </Box>
      <MasterTable
        data={data}
        columns={columns}
        isServerSide={true}
        handleView={handleView}
        handleEdit={handleEdit}
        handleDelete={handleDelete}
        tableTotalCount={tableTotalCount}
        tableOutputEvent={tableOutputEvent}
      />
      {openDrawer ? (
        <AddQuestion
          open={openDrawer}
          setOpenDrawer={setOpenDrawer}
          selectedData={selectedData}
          handleCloseDrawer={handleCloseDrawer}
          formType={
            selectedData.isView ? "view" : selectedData._id ? "edit" : "add"
          }
          // formType={selectedData._id ? "edit" : "add"}
          GetQuestionData={GetQuestionData}
        />
      ) : null}
      <ConfirmBox
        open={confirmDeleteOpen}
        title="Are you sure you want to delete?"
        content={`You are about to delete this item`}
        confirmButton={"Delete"}
        setOpenConfirmBox={() => setConfirmDeleteOpen(false)}
        Function={deleteFunction}
      />
    </div>
  );
};

export default Questions;
